export function shouldShowStockLimitInfo(
  stockValue: number | null,
  maxQuantity: number | null,
): boolean {
  return stockValue > 0 && (!maxQuantity || stockValue <= maxQuantity);
}
